import type { AdjustmentVersion } from '../../../react-query/useGetSharpenedImages';

export const FILTER_VERSIONS: Array<{
  version: AdjustmentVersion;
  label: string;
  description: string;
}> = [
  {
    version: 'original',
    label: 'Original',
    description: 'No enhancement (original)',
  },
  {
    version: '7.6.0.enhanced',
    label: 'A',
    description: 'Version A (7.6.0.enhanced)',
  },
  {
    version: '7.5.3.enhanced',
    label: 'B',
    description: 'Version B (7.5.3.enhanced)',
  },
  {
    version: '7.5.2.enhanced',
    label: 'C',
    description: 'Version C (7.5.2.enhanced)',
  },
  {
    version: '7.5.1.enhanced',
    label: 'D',
    description: 'Version D (7.5.1.enhanced)',
  },
  {
    version: '7.5.0.enhanced',
    label: 'E',
    description: 'Version E (7.5.0.enhanced)',
  },
  {
    version: '7.4.1.enhanced',
    label: 'F',
    description: 'Version F (7.4.1.enhanced)',
  },
  {
    version: '7.4.0.enhanced',
    label: 'G',
    description: 'Version G (7.4.0.enhanced)',
  }, 
];

export const getFilterLabel = (version: string): string => {
  const filter = FILTER_VERSIONS.find((f) => f.version === version);
  return filter ? filter.label : version;
};

